import { Button } from "waapi/waap-ui/components/Button/Button.js";
import { IconButton } from "waapi/waap-ui/components/IconButton/IconButton.js";
import { Send2Bold } from "waapi/waap-ui/components/Iconsax/Send2Bold.js";
import { ITheme } from "waapi/waap-ui/components/Theme/Theme.types.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import { useTheme } from "styled-components";
import { useTranslation } from "../../../../customHooks/useTranslation/index.js";
import { StyledCardBody, StyledContainer, StyledHeaderBody, StyledText, StyledTextContainer, SvgContainer } from "./styles.js";

export const LargeCustomizableButton = (): JSX.Element => {
    const { t, translations } = useTranslation();
    const theme = useTheme() as ITheme;

    return (
        <StyledContainer direction="column" align="center">
            <StyledCardBody>
                <StyledHeaderBody gap="12" align="center">
                    <SvgContainer direction="column" justify="center" align="center" gap="4">
                        <a href={t(translations.intercom_feedback.icon_link())} target="_blank" rel="noreferrer">
                            <IconButton icon={Send2Bold} size="medium" color="gradient" />
                        </a>
                    </SvgContainer>
                    <StyledTextContainer direction="column">
                        <StyledText size={TextSize["X-SMALL"]} weight={TextWeight.BOLD} align="left">
                            {t(translations.intercom_feedback.title())}
                        </StyledText>
                        <StyledText size={TextSize["XX-SMALL"]} color={theme.grayscale[70]} align="left">
                            {t(translations.intercom_feedback.subtitle())}
                        </StyledText>
                    </StyledTextContainer>
                </StyledHeaderBody>
                <a href={t(translations.intercom_feedback.link())} target="_blank" rel="noreferrer">
                    <Button size="small" variant="tinted">
                        {t(translations.intercom_feedback.button())}
                    </Button>
                </a>
            </StyledCardBody>
        </StyledContainer>
    );
};
